import { render, staticRenderFns } from "./search.vue?vue&type=template&id=3877823c&"
import script from "./search.js?vue&type=script&lang=js&"
export * from "./search.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3877823c')) {
      api.createRecord('3877823c', component.options)
    } else {
      api.reload('3877823c', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=3877823c&", function () {
      api.rerender('3877823c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/inputs/search.vue"
export default component.exports